var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.003,
    height: 26.005,
    viewBox: "0 0 26.003 26.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #b4302b;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #b4302b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10190",
    "data-name": "Group 10190",
    transform: "translate(-366.5 -168.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10189",
    "data-name": "Group 10189"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1821",
    "data-name": "Ellipse 1821",
    className: "cls-1",
    cx: 12.501,
    cy: 12.502,
    rx: 12.501,
    ry: 12.502,
    transform: "translate(367 169)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844",
    transform: "translate(373 175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7201",
    "data-name": "Path 7201",
    className: "cls-2",
    d: "M42.529,235.881l-.549.549a.757.757,0,0,1-1.1,0L29.835,225.381a.757.757,0,0,1,0-1.1l.549-.549a.757.757,0,0,1,1.1,0l11.049,11.049A.756.756,0,0,1,42.529,235.881Z",
    transform: "translate(-29.6 -223.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7202",
    "data-name": "Path 7202",
    className: "cls-2",
    d: "M41.981,223.635l.549.549a.757.757,0,0,1,0,1.1L31.481,236.408a.757.757,0,0,1-1.1,0l-.549-.549a.757.757,0,0,1,0-1.1l11.049-11.127A.757.757,0,0,1,41.981,223.635Z",
    transform: "translate(-29.6 -223.4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.99a5e2db59efb2cf9d52bfd099cd3329.svg";
export { ForwardRef as ReactComponent };